var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningAmberR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.99329L13.02 12.6666H2.98L8 3.99329ZM1.82667 12C1.31333 12.8866 1.95333 14 2.98 14H13.02C14.0467 14 14.6867 12.8866 14.1733 12L9.15333 3.32662C8.64 2.43995 7.36 2.43995 6.84667 3.32662L1.82667 12ZM7.33333 7.33329V8.66662C7.33333 9.03329 7.63333 9.33329 8 9.33329C8.36667 9.33329 8.66667 9.03329 8.66667 8.66662V7.33329C8.66667 6.96662 8.36667 6.66662 8 6.66662C7.63333 6.66662 7.33333 6.96662 7.33333 7.33329ZM7.33333 10.6666H8.66667V12H7.33333V10.6666Z",
    fill: "#EF5350"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmberR);
export default __webpack_public_path__ + "static/media/warning_amber_r.4b8e2b25.svg";
export { ForwardRef as ReactComponent };